var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 194,
    viewBox: "0 0 148 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1424_243927)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 194,
    rx: 8.81633,
    fill: "#E9F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.071 101.965C111.466 71.7625 136.734 48 167.552 48C191.351 48 211.824 62.1673 221.028 82.5101C241.661 84.9423 257.667 102.491 257.667 123.778C257.667 146.728 239.062 165.333 216.111 165.333H122C103.775 165.333 89 150.559 89 132.333C89 118.691 97.273 106.994 109.071 101.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1424_243927)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 40,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.5,
    y: 40.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#EDEDED",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.679 56.3258C125.59 56.6135 125.396 56.8691 125.11 57.0325L120.873 59.4599C120.275 59.8013 119.512 59.5989 119.169 59.0084C118.823 58.4147 119.027 57.6592 119.624 57.3168L121.992 55.9626L119.624 54.6049C119.027 54.263 118.822 53.5074 119.169 52.9158C119.512 52.3238 120.275 52.1208 120.873 52.4622L125.11 54.8881C125.408 55.0585 125.607 55.3288 125.69 55.6311C125.718 55.7283 125.731 55.8254 125.736 55.9231C125.739 56.0576 125.722 56.1939 125.679 56.3258ZM126.829 58.5993C127.474 58.6453 127.984 59.1805 127.984 59.8317V64.6853C127.984 65.3697 127.424 65.9237 126.736 65.9237C126.046 65.9237 125.488 65.3697 125.488 64.6853V61.9706L123.112 63.329C122.516 63.6731 121.755 63.4696 121.408 62.8786C121.064 62.2864 121.268 61.5272 121.865 61.1853L126.105 58.7609C126.333 58.6291 126.585 58.5786 126.829 58.5993ZM131.172 53.3246C130.525 53.2773 130.016 52.7412 130.016 52.0905V47.2363C130.016 46.5542 130.573 46 131.264 46C131.955 46 132.513 46.5542 132.513 47.2363V49.9526L134.887 48.592C135.484 48.2501 136.246 48.453 136.59 49.0441C136.933 49.6384 136.731 50.3944 136.134 50.7363L131.894 53.1628C131.666 53.293 131.414 53.344 131.172 53.3246ZM121.865 50.7363C121.268 50.3944 121.064 49.6384 121.408 49.0441C121.755 48.453 122.516 48.2501 123.112 48.592L125.488 49.9526V47.2363C125.488 46.5542 126.046 46 126.736 46C127.424 46 127.984 46.5542 127.984 47.2363V52.0905C127.984 52.7412 127.474 53.2773 126.829 53.3246C126.585 53.344 126.333 53.293 126.105 53.1628L121.865 50.7363ZM129.479 58.1819C129.429 58.2335 129.332 58.2753 129.258 58.2753H128.74C128.669 58.2753 128.57 58.2335 128.519 58.1819L126.757 56.437C126.707 56.3877 126.666 56.2888 126.666 56.2194V55.7044C126.666 55.6333 126.707 55.5346 126.757 55.4846L128.519 53.7391C128.57 53.6882 128.669 53.6474 128.74 53.6474H129.258C129.33 53.6474 129.429 53.6882 129.479 53.7391L131.242 55.4846C131.292 55.5346 131.333 55.6333 131.333 55.7044V56.2194C131.333 56.2888 131.292 56.3877 131.242 56.437L129.479 58.1819ZM129.833 55.9524C129.833 55.8818 129.79 55.7836 129.74 55.7315L129.229 55.2278C129.179 55.1779 129.08 55.1366 129.009 55.1366H128.989C128.918 55.1366 128.819 55.1779 128.77 55.2278L128.259 55.7315C128.208 55.7836 128.169 55.8818 128.169 55.9524V55.9725C128.169 56.0419 128.208 56.1391 128.259 56.1901L128.77 56.6948C128.82 56.7448 128.918 56.7859 128.989 56.7859H129.009C129.08 56.7859 129.179 56.7448 129.229 56.6948L129.74 56.1901C129.79 56.1391 129.833 56.0419 129.833 55.9725V55.9524ZM136.134 61.1853C136.731 61.5272 136.933 62.2864 136.59 62.8786C136.246 63.4696 135.483 63.6731 134.887 63.329L132.513 61.9706V64.6853C132.513 65.3697 131.955 65.9237 131.264 65.9237C130.573 65.9237 130.016 65.3697 130.016 64.6853V59.8317C130.016 59.1805 130.525 58.6453 131.172 58.5993C131.414 58.5786 131.666 58.6291 131.894 58.7609L136.134 61.1853ZM136.007 55.9626L138.375 57.3168C138.973 57.6592 139.178 58.4147 138.832 59.0084C138.487 59.5989 137.724 59.8013 137.128 59.4599L132.888 57.0325C132.605 56.8691 132.409 56.6135 132.321 56.3258C132.28 56.1939 132.26 56.0576 132.265 55.9231C132.268 55.8254 132.282 55.7283 132.309 55.6311C132.394 55.3288 132.593 55.0585 132.888 54.8881L137.128 52.4622C137.724 52.1208 138.487 52.3238 138.832 52.9158C139.178 53.5074 138.973 54.263 138.375 54.6049L136.007 55.9626Z",
    fill: "#29B5E8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1424_243927)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 122,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 122.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#C9C9C9",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0033 128.139L91.5922 133.206C91.3978 133.183 91.2033 133.172 91.0033 133.172C90.7533 133.172 90.5089 133.189 90.27 133.228L90.0366 130.772C90.0311 130.694 90.0922 130.628 90.17 130.628H90.5866L90.3866 128.144C90.3811 128.067 90.4422 128 90.5144 128H91.8755C91.9533 128 92.0144 128.067 92.0033 128.144V128.139ZM88.57 128.389C88.5478 128.317 88.47 128.272 88.3978 128.3L87.12 128.767C87.0478 128.794 87.0144 128.878 87.0478 128.944L88.0866 131.211L87.6922 131.356C87.62 131.383 87.5866 131.467 87.62 131.533L88.6811 133.761C89.0644 133.55 89.4811 133.389 89.92 133.289L88.5755 128.389H88.57ZM85.4366 129.8L88.3755 133.944C88.0033 134.189 87.6644 134.478 87.3755 134.811L85.6144 133.078C85.5589 133.022 85.5644 132.933 85.62 132.883L85.9422 132.617L84.1922 130.844C84.1366 130.789 84.1422 130.7 84.2033 130.65L85.2422 129.778C85.3033 129.728 85.3866 129.739 85.4311 129.8H85.4366ZM82.97 132.2C82.9089 132.156 82.82 132.178 82.7811 132.244L82.1033 133.422C82.0644 133.489 82.0922 133.572 82.1589 133.606L84.4144 134.672L84.2033 135.033C84.1644 135.1 84.1922 135.189 84.2644 135.217L86.5089 136.244C86.67 135.828 86.8866 135.439 87.1533 135.089L82.97 132.2ZM81.3089 135.4C81.32 135.322 81.3978 135.278 81.47 135.294L86.3866 136.578C86.2589 136.994 86.1866 137.433 86.1755 137.889L83.7144 137.689C83.6366 137.683 83.5811 137.611 83.5978 137.533L83.67 137.122L81.1866 136.889C81.1089 136.883 81.0589 136.811 81.07 136.733L81.3033 135.394L81.3089 135.4ZM81.1255 138.722C81.0478 138.728 80.9978 138.8 81.0089 138.878L81.2478 140.217C81.2589 140.294 81.3366 140.339 81.4089 140.322L83.82 139.694L83.8922 140.106C83.9033 140.183 83.9811 140.228 84.0533 140.211L86.4311 139.556C86.2922 139.144 86.2033 138.706 86.1811 138.256L81.12 138.722H81.1255ZM81.9144 142.244C81.8755 142.178 81.9033 142.094 81.97 142.061L86.5589 139.883C86.7311 140.294 86.9644 140.678 87.2422 141.022L85.2311 142.456C85.17 142.5 85.0811 142.483 85.0422 142.417L84.8311 142.05L82.7811 143.467C82.72 143.511 82.6311 143.489 82.5922 143.422L81.9089 142.244H81.9144ZM87.4755 141.289L83.9033 144.906C83.8478 144.961 83.8533 145.05 83.9144 145.1L84.9589 145.972C85.02 146.022 85.1033 146.011 85.1478 145.95L86.5922 143.917L86.9144 144.189C86.9755 144.239 87.0644 144.228 87.1089 144.161L88.5089 142.128C88.1311 141.894 87.7811 141.611 87.4811 141.289H87.4755ZM86.77 147.094C86.6978 147.067 86.6644 146.983 86.6978 146.917L88.8144 142.294C89.2033 142.494 89.6255 142.644 90.0644 142.728L89.4422 145.117C89.4255 145.189 89.3422 145.233 89.27 145.206L88.8755 145.061L88.2144 147.467C88.1922 147.539 88.1144 147.583 88.0422 147.556L86.7644 147.089L86.77 147.094ZM90.4144 142.789L90.0033 147.856C89.9978 147.933 90.0589 148 90.1311 148H91.4922C91.57 148 91.6311 147.933 91.62 147.856L91.42 145.372H91.8366C91.9144 145.372 91.9755 145.306 91.97 145.228L91.7366 142.772C91.4978 142.811 91.2533 142.828 91.0033 142.828C90.8033 142.828 90.6089 142.817 90.4144 142.789ZM95.3144 129.072C95.3478 129 95.3144 128.922 95.2422 128.894L93.9644 128.428C93.8922 128.4 93.8144 128.444 93.7922 128.517L93.1311 130.922L92.7366 130.778C92.6644 130.75 92.5866 130.794 92.5644 130.867L91.9422 133.256C92.3866 133.344 92.8033 133.494 93.1922 133.689L95.3144 129.072ZM98.1033 131.089L94.5311 134.706C94.2311 134.383 93.8866 134.1 93.5033 133.867L94.9033 131.833C94.9478 131.772 95.0366 131.756 95.0978 131.806L95.42 132.078L96.8644 130.044C96.9089 129.983 96.9978 129.972 97.0533 130.022L98.0978 130.894C98.1589 130.944 98.1589 131.033 98.1089 131.089H98.1033ZM100.037 133.933C100.109 133.9 100.131 133.817 100.092 133.75L99.4089 132.572C99.37 132.506 99.2811 132.489 99.22 132.528L97.17 133.944L96.9589 133.583C96.92 133.517 96.8311 133.494 96.77 133.544L94.7589 134.978C95.0366 135.322 95.2644 135.706 95.4422 136.117L100.031 133.939L100.037 133.933ZM100.759 135.778L100.992 137.117C101.003 137.194 100.953 137.261 100.876 137.272L95.8144 137.744C95.7922 137.289 95.7033 136.856 95.5644 136.444L97.9422 135.789C98.0144 135.767 98.0922 135.817 98.1033 135.894L98.1755 136.306L100.587 135.678C100.659 135.661 100.737 135.706 100.748 135.783L100.759 135.778ZM100.531 140.694C100.603 140.711 100.681 140.667 100.692 140.589L100.926 139.25C100.937 139.172 100.887 139.106 100.809 139.094L98.3255 138.861L98.3978 138.45C98.4089 138.372 98.3589 138.306 98.2811 138.294L95.82 138.094C95.8089 138.55 95.7366 138.989 95.6089 139.406L100.526 140.689L100.531 140.694ZM99.22 143.75C99.1811 143.817 99.0922 143.833 99.0311 143.794L94.8478 140.906C95.1144 140.556 95.3311 140.167 95.4922 139.75L97.7366 140.778C97.8089 140.811 97.8366 140.894 97.7978 140.961L97.5866 141.322L99.8422 142.389C99.9089 142.422 99.9366 142.506 99.8978 142.572L99.22 143.75ZM93.6255 142.044L96.5644 146.189C96.6089 146.25 96.6978 146.261 96.7533 146.211L97.7922 145.339C97.8533 145.289 97.8533 145.2 97.8033 145.144L96.0533 143.372L96.3755 143.106C96.4366 143.056 96.4366 142.967 96.3811 142.911L94.62 141.178C94.3255 141.511 93.9922 141.806 93.62 142.044H93.6255ZM93.5978 147.689C93.5255 147.717 93.4478 147.672 93.4255 147.6L92.0811 142.7C92.52 142.6 92.9366 142.439 93.32 142.228L94.3811 144.456C94.4144 144.528 94.3811 144.611 94.3089 144.633L93.9144 144.778L94.9533 147.044C94.9866 147.117 94.9533 147.194 94.8811 147.222L93.6033 147.689H93.5978Z",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1424_243927)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 13.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#EDEDED",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1819 30.8179C27.1819 31.146 27.2173 31.4121 27.2794 31.6072C27.3504 31.8023 27.4391 32.0152 27.5632 32.2458C27.6076 32.3167 27.6253 32.3877 27.6253 32.4498C27.6253 32.5385 27.5721 32.6272 27.4568 32.7158L26.8981 33.0883C26.8182 33.1416 26.7384 33.1682 26.6675 33.1682C26.5788 33.1682 26.4901 33.1238 26.4014 33.044C26.2772 32.911 26.1708 32.7691 26.0821 32.6272C25.9934 32.4764 25.9047 32.3079 25.8072 32.1039C25.1154 32.9198 24.2462 33.3278 23.1997 33.3278C22.4547 33.3278 21.8604 33.115 21.4258 32.6892C20.9913 32.2635 20.7695 31.6959 20.7695 30.9864C20.7695 30.2325 21.0356 29.6205 21.5766 29.1593C22.1176 28.6982 22.836 28.4676 23.7495 28.4676C24.0511 28.4676 24.3615 28.4942 24.6897 28.5385C25.0178 28.5829 25.3548 28.6538 25.7096 28.7336V28.0862C25.7096 27.4121 25.5677 26.9421 25.2928 26.6671C25.0089 26.3922 24.53 26.2592 23.8471 26.2592C23.5367 26.2592 23.2174 26.2946 22.8892 26.3745C22.5611 26.4543 22.2418 26.5518 21.9314 26.676C21.7895 26.7381 21.683 26.7736 21.621 26.7913C21.5589 26.809 21.5145 26.8179 21.4791 26.8179C21.3549 26.8179 21.2928 26.7292 21.2928 26.543V26.1084C21.2928 25.9665 21.3105 25.8601 21.3549 25.798C21.3992 25.7359 21.4791 25.6738 21.6032 25.6117C21.9136 25.4521 22.2861 25.319 22.7207 25.2126C23.1553 25.0973 23.6165 25.0441 24.1043 25.0441C25.1597 25.0441 25.9313 25.2836 26.428 25.7625C26.9158 26.2414 27.1641 26.9687 27.1641 27.9443V30.8179H27.1819ZM23.581 32.166C23.8737 32.166 24.1753 32.1127 24.4945 32.0063C24.8138 31.8999 25.0976 31.7048 25.3371 31.4387C25.479 31.2702 25.5854 31.0839 25.6386 30.8711C25.6919 30.6582 25.7273 30.401 25.7273 30.0995V29.727C25.4701 29.6649 25.1952 29.6117 24.9114 29.5762C24.6276 29.5407 24.3526 29.523 24.0777 29.523C23.4835 29.523 23.0489 29.6383 22.7562 29.8777C22.4635 30.1172 22.3216 30.4542 22.3216 30.8977C22.3216 31.3145 22.428 31.6249 22.6498 31.8378C22.8626 32.0595 23.173 32.166 23.581 32.166ZM30.7029 33.1238C30.5432 33.1238 30.4368 33.0972 30.3659 33.0351C30.2949 32.9819 30.2328 32.8577 30.1796 32.6892L28.0954 25.8335C28.0422 25.6561 28.0156 25.5408 28.0156 25.4787C28.0156 25.3368 28.0865 25.257 28.2284 25.257H29.0976C29.2661 25.257 29.3814 25.2836 29.4435 25.3457C29.5144 25.3989 29.5676 25.523 29.6209 25.6915L31.1109 31.5629L32.4944 25.6915C32.5388 25.5142 32.592 25.3989 32.6629 25.3457C32.7339 25.2924 32.8581 25.257 33.0177 25.257H33.7272C33.8957 25.257 34.011 25.2836 34.082 25.3457C34.1529 25.3989 34.215 25.523 34.2505 25.6915L35.6518 31.6338L37.1862 25.6915C37.2394 25.5142 37.3015 25.3989 37.3635 25.3457C37.4345 25.2924 37.5498 25.257 37.7094 25.257H38.5343C38.6762 25.257 38.756 25.3279 38.756 25.4787C38.756 25.523 38.7471 25.5674 38.7382 25.6206C38.7294 25.6738 38.7116 25.7448 38.6762 25.8423L36.5387 32.6981C36.4855 32.8755 36.4234 32.9908 36.3525 33.044C36.2815 33.0972 36.1662 33.1327 36.0154 33.1327H35.2527C35.0842 33.1327 34.9689 33.1061 34.8979 33.044C34.827 32.9819 34.7649 32.8666 34.7294 32.6892L33.3547 26.9687L31.9889 32.6804C31.9445 32.8577 31.8913 32.973 31.8204 33.0351C31.7494 33.0972 31.6253 33.1238 31.4656 33.1238H30.7029ZM42.0996 33.3633C41.6384 33.3633 41.1772 33.3101 40.7338 33.2036C40.2903 33.0972 39.9444 32.9819 39.7138 32.8489C39.5719 32.7691 39.4744 32.6804 39.4389 32.6005C39.4034 32.5207 39.3857 32.432 39.3857 32.3522V31.8999C39.3857 31.7136 39.4566 31.6249 39.5897 31.6249C39.6429 31.6249 39.6961 31.6338 39.7493 31.6516C39.8025 31.6693 39.8824 31.7048 39.971 31.7402C40.2726 31.8733 40.6008 31.9797 40.9466 32.0507C41.3014 32.1216 41.6473 32.1571 42.0021 32.1571C42.5608 32.1571 42.9954 32.0595 43.2969 31.8644C43.5985 31.6693 43.7581 31.3855 43.7581 31.0219C43.7581 30.7735 43.6783 30.5695 43.5187 30.401C43.359 30.2325 43.0575 30.0817 42.6229 29.9398L41.3369 29.5407C40.6894 29.3367 40.2105 29.0352 39.9178 28.6361C39.6252 28.2458 39.4744 27.8113 39.4744 27.3501C39.4744 26.9776 39.5542 26.6494 39.7138 26.3656C39.8735 26.0818 40.0863 25.8335 40.3524 25.6383C40.6185 25.4343 40.92 25.2836 41.2748 25.1771C41.6296 25.0707 42.0021 25.0264 42.3923 25.0264C42.5874 25.0264 42.7914 25.0352 42.9865 25.0618C43.1905 25.0885 43.3768 25.1239 43.563 25.1594C43.7404 25.2037 43.9089 25.2481 44.0686 25.3013C44.2282 25.3545 44.3524 25.4077 44.4411 25.461C44.5652 25.5319 44.6539 25.6029 44.7071 25.6827C44.7603 25.7536 44.7869 25.8512 44.7869 25.9754V26.3922C44.7869 26.5785 44.716 26.676 44.583 26.676C44.512 26.676 44.3967 26.6405 44.2459 26.5696C43.7404 26.339 43.1728 26.2237 42.5431 26.2237C42.0375 26.2237 41.6384 26.3035 41.3635 26.472C41.0885 26.6405 40.9466 26.8977 40.9466 27.2614C40.9466 27.5097 41.0353 27.7226 41.2127 27.8911C41.3901 28.0596 41.7183 28.2281 42.1883 28.3789L43.4477 28.778C44.0863 28.982 44.5475 29.2658 44.8224 29.6294C45.0974 29.993 45.2304 30.4099 45.2304 30.8711C45.2304 31.2524 45.1506 31.5983 44.9998 31.8999C44.8402 32.2014 44.6273 32.4675 44.3524 32.6804C44.0774 32.9021 43.7493 33.0617 43.3679 33.177C42.9688 33.3012 42.5519 33.3633 42.0996 33.3633Z",
    fill: "#252F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5759 36.1747C42.5249 36.0594 44.618 35.811 44.9905 36.29C45.363 36.76 44.5736 38.7378 44.2189 39.6158C44.1125 39.8819 44.3431 39.9883 44.5825 39.7844C46.1435 38.4717 46.5514 35.7312 46.2322 35.3321C45.9129 34.9419 43.1723 34.6048 41.5049 35.7755C41.2477 35.9618 41.2921 36.2101 41.5759 36.1747Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9729 40.9728C36.6181 40.9728 40.8575 39.8287 43.7755 37.6735C44.2544 37.3188 43.8375 36.7778 43.3497 36.9995C40.0771 38.3831 36.5206 39.0571 33.2834 39.0571C28.4852 39.0571 23.8467 37.7356 20.0862 35.5538C19.758 35.3587 19.5097 35.6957 19.7846 35.9441C23.2613 39.0837 27.8644 40.9728 32.9729 40.9728Z",
    fill: "#FF9900"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1424_243927)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 73,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 73.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#EDEDED",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.229 82.3333H45.9286L38.9737 102.939C38.9023 103.151 38.7662 103.335 38.5846 103.466C38.4031 103.596 38.1853 103.666 37.9618 103.666H32.7478C32.5785 103.666 32.4116 103.626 32.2609 103.549C32.1102 103.471 31.9801 103.359 31.8814 103.222C31.7826 103.084 31.718 102.925 31.6929 102.758C31.6678 102.59 31.683 102.419 31.7371 102.259L38.2168 83.0599C38.2882 82.848 38.4243 82.664 38.6059 82.5336C38.7875 82.4032 39.0054 82.3333 39.229 82.3333Z",
    fill: "url(#paint0_linear_1424_243927)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9644 96.1543H38.3404C38.2416 96.1542 38.1451 96.1838 38.0634 96.2394C37.9817 96.2949 37.9187 96.3737 37.8824 96.4656C37.8462 96.5575 37.8385 96.6581 37.8603 96.7545C37.8821 96.8508 37.9324 96.9384 38.0046 97.0057L44.8314 103.377C45.0301 103.563 45.2918 103.666 45.5637 103.666H51.5794L48.9644 96.1543Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2291 82.333C39.0031 82.3321 38.7827 82.4036 38.6002 82.5368C38.4177 82.6701 38.2825 82.8582 38.2146 83.0738L31.7452 102.241C31.6874 102.402 31.6693 102.575 31.6923 102.744C31.7153 102.914 31.7789 103.075 31.8775 103.215C31.9761 103.355 32.107 103.469 32.259 103.547C32.411 103.626 32.5797 103.666 32.7507 103.666H38.0993C38.2985 103.63 38.4847 103.542 38.6388 103.411C38.793 103.28 38.9096 103.111 38.9767 102.92L40.2668 99.1176L44.8751 103.416C45.0682 103.575 45.3104 103.664 45.5611 103.666H51.5544L48.9258 96.1543L41.2631 96.1561L45.9529 82.333H39.2291Z",
    fill: "url(#paint1_linear_1424_243927)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7859 83.0586C47.7146 82.8471 47.5787 82.6633 47.3974 82.5332C47.2161 82.403 46.9985 82.333 46.7753 82.333H39.3086C39.5318 82.333 39.7494 82.403 39.9307 82.5332C40.112 82.6634 40.2479 82.8471 40.3193 83.0586L46.7992 102.258C46.8534 102.419 46.8685 102.59 46.8435 102.757C46.8184 102.925 46.7538 103.084 46.6551 103.221C46.5563 103.359 46.4262 103.471 46.2755 103.548C46.1248 103.626 45.9579 103.666 45.7885 103.666H53.2554C53.4248 103.666 53.5917 103.626 53.7423 103.548C53.893 103.471 54.0231 103.359 54.1218 103.221C54.2205 103.084 54.2851 102.925 54.3102 102.757C54.3352 102.59 54.32 102.419 54.2659 102.258L47.7859 83.0586Z",
    fill: "url(#paint2_linear_1424_243927)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1424_243927)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 7,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 7.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#EDEDED",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.794 23.2032C112.794 22.5535 112.735 21.9288 112.627 21.3291H103.998V24.8773H108.929C108.712 26.0184 108.063 26.9847 107.088 27.6342V29.9415H110.062C111.794 28.3423 112.794 25.9934 112.794 23.2032Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.999 32.157C106.472 32.157 108.546 31.3408 110.062 29.9414L107.089 27.6343C106.272 28.1841 105.231 28.5172 103.999 28.5172C101.616 28.5172 99.5924 26.9097 98.8678 24.7441H95.8193V27.1096C97.3269 30.0997 100.417 32.157 103.999 32.157Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8672 24.7357C98.684 24.186 98.5757 23.6029 98.5757 22.9949C98.5757 22.3869 98.684 21.8038 98.8672 21.2541V18.8887H95.8188C95.1941 20.1214 94.8359 21.5123 94.8359 22.9949C94.8359 24.4774 95.1941 25.8685 95.8188 27.1012L98.1926 25.2521L98.8672 24.7357Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.999 17.4812C105.348 17.4812 106.547 17.9476 107.505 18.8471L110.129 16.2235C108.538 14.7409 106.472 13.833 103.999 13.833C100.417 13.833 97.3269 15.8903 95.8193 18.8888L98.8678 21.2543C99.5924 19.0887 101.616 17.4812 103.999 17.4812Z",
    fill: "#EA4335"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1424_243927)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 51,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 51.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#EDEDED",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3731 69.1128C83.3731 70.042 82.6221 70.793 81.6929 70.793C80.7637 70.793 80.0127 70.042 80.0127 69.1128C80.0127 68.1836 80.7637 67.4326 81.6929 67.4326H83.3731V69.1128ZM84.2131 69.1128C84.2131 68.1836 84.9641 67.4326 85.8933 67.4326C86.8225 67.4326 87.5735 68.1836 87.5735 69.1128V73.3133C87.5735 74.2425 86.8225 74.9935 85.8933 74.9935C84.9641 74.9935 84.2131 74.2425 84.2131 73.3133V69.1128Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8934 62.3663C84.9642 62.3663 84.2132 61.6153 84.2132 60.6861C84.2132 59.7569 84.9642 59.0059 85.8934 59.0059C86.8226 59.0059 87.5735 59.7569 87.5735 60.6861V62.3663H85.8934ZM85.8934 63.2191C86.8226 63.2191 87.5735 63.9701 87.5735 64.8993C87.5735 65.8285 86.8226 66.5795 85.8934 66.5795H81.6802C80.751 66.5795 80 65.8285 80 64.8993C80 63.9701 80.751 63.2191 81.6802 63.2191H85.8934Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6267 64.8993C92.6267 63.9701 93.3777 63.2191 94.3069 63.2191C95.2361 63.2191 95.9871 63.9701 95.9871 64.8993C95.9871 65.8285 95.2361 66.5795 94.3069 66.5795H92.6267V64.8993ZM91.7866 64.8993C91.7866 65.8285 91.0356 66.5795 90.1064 66.5795C89.1773 66.5795 88.4263 65.8285 88.4263 64.8993V60.6861C88.4263 59.7569 89.1773 59.0059 90.1064 59.0059C91.0356 59.0059 91.7866 59.7569 91.7866 60.6861V64.8993Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1064 71.6331C91.0356 71.6331 91.7866 72.3841 91.7866 73.3133C91.7866 74.2425 91.0356 74.9935 90.1064 74.9935C89.1773 74.9935 88.4263 74.2425 88.4263 73.3133V71.6331H90.1064ZM90.1064 70.793C89.1773 70.793 88.4263 70.042 88.4263 69.1128C88.4263 68.1836 89.1773 67.4326 90.1064 67.4326H94.3196C95.2488 67.4326 95.9998 68.1836 95.9998 69.1128C95.9998 70.042 95.2488 70.793 94.3196 70.793H90.1064Z",
    fill: "#ECB22E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1424_243927)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 130,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 130.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#EDEDED",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4738 142.444H27.0838L28.8223 140.705L28.9077 139.967C27.9118 139.088 26.7082 138.478 25.4107 138.193C24.1132 137.909 22.7645 137.959 21.4921 138.341C20.2197 138.723 19.0656 139.422 18.1388 140.374C17.212 141.326 16.5431 142.498 16.1953 143.78C16.389 143.7 16.6035 143.688 16.8053 143.743L20.2823 143.17C20.2823 143.17 20.4592 142.877 20.5507 142.895C21.2957 142.077 22.3253 141.575 23.4287 141.491C24.5321 141.407 25.6259 141.748 26.486 142.444H26.4738Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2994 143.78C30.8998 142.308 30.0793 140.986 28.9387 139.974L26.4987 142.414C27.0072 142.829 27.4147 143.355 27.6905 143.951C27.9663 144.547 28.1032 145.197 28.0908 145.854V146.287C28.3759 146.287 28.6583 146.343 28.9218 146.452C29.1853 146.562 29.4247 146.722 29.6263 146.923C29.828 147.125 29.9879 147.364 30.0971 147.628C30.2062 147.891 30.2624 148.174 30.2624 148.459C30.2624 148.744 30.2062 149.026 30.0971 149.29C29.9879 149.553 29.828 149.793 29.6263 149.994C29.4247 150.196 29.1853 150.356 28.9218 150.465C28.6583 150.574 28.3759 150.63 28.0908 150.63H23.7476L23.3145 151.07V153.674L23.7476 154.107H28.0908C29.3036 154.117 30.4872 153.736 31.4666 153.02C32.446 152.305 33.1691 151.293 33.529 150.135C33.8889 148.977 33.8663 147.733 33.4648 146.589C33.0633 145.444 32.304 144.46 31.2994 143.78Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3982 154.082H23.7414V150.605H19.3982C19.0888 150.605 18.7829 150.539 18.5015 150.41L17.8915 150.599L16.1408 152.338L15.9883 152.948C16.97 153.689 18.168 154.088 19.3982 154.082Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3981 142.804C18.2213 142.811 17.0761 143.185 16.1224 143.875C15.1687 144.564 14.4541 145.534 14.0786 146.65C13.703 147.765 13.6852 148.97 14.0275 150.096C14.3699 151.221 15.0553 152.212 15.9882 152.93L18.5075 150.41C18.1873 150.266 17.907 150.046 17.6907 149.769C17.4743 149.492 17.3283 149.167 17.2653 148.821C17.2022 148.476 17.2239 148.12 17.3285 147.785C17.4332 147.449 17.6176 147.144 17.866 146.896C18.1144 146.647 18.4194 146.463 18.7548 146.358C19.0901 146.254 19.4459 146.232 19.7915 146.295C20.1371 146.358 20.4622 146.504 20.739 146.721C21.0158 146.937 21.2359 147.217 21.3806 147.537L23.8999 145.018C23.3711 144.327 22.6896 143.767 21.9086 143.383C21.1276 142.999 20.2684 142.801 19.3981 142.804Z",
    fill: "#FBBC05"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1424_243927)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 166,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 166.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#EDEDED",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0688 192.709C61.5862 193.031 62.4462 193.39 63.3555 193.39C64.1835 193.39 64.9528 193.15 65.5902 192.741C65.5902 192.741 65.5915 192.741 65.5928 192.739L67.9995 191.235V196.666C67.6182 196.666 67.2342 196.562 66.9008 196.354L61.0688 192.709Z",
    fill: "#225086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4707 176.009L56.4707 187.289C55.6987 188.161 55.9 189.478 56.9013 190.104C56.9013 190.104 60.6027 192.417 61.0693 192.709C61.5867 193.032 62.4467 193.39 63.356 193.39C64.184 193.39 64.9533 193.15 65.5907 192.741C65.5907 192.741 65.592 192.741 65.5933 192.74L68 191.236L62.1813 187.598L68.0013 181.033V175.333C67.436 175.333 66.8707 175.558 66.4707 176.009Z",
    fill: "#66DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1812 187.599L62.2505 187.641L67.9998 191.236H68.0012V181.035L67.9998 181.033L62.1812 187.599Z",
    fill: "#CBF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0988 190.104C80.1001 189.479 80.3015 188.161 79.5295 187.289L72.9681 179.888C72.4388 179.641 71.8455 179.5 71.2175 179.5C69.9841 179.5 68.8815 180.032 68.1481 180.868L68.0028 181.032L73.8215 187.597L68.0015 191.235V196.665C68.3841 196.665 68.7655 196.561 69.0988 196.353L79.0988 190.103V190.104Z",
    fill: "#074793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0013 175.333V181.033L68.1467 180.869C68.88 180.033 69.9827 179.501 71.216 179.501C71.8453 179.501 72.4373 179.644 72.9667 179.889L69.528 176.01C69.1293 175.56 68.564 175.334 68 175.334L68.0013 175.333Z",
    fill: "#0294E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8201 187.598L68.0015 181.034V191.234L73.8201 187.598Z",
    fill: "#96BCC2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1424_243927",
    x: 109,
    y: 40,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.552941 0 0 0 0 0.929412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1424_243927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1424_243927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1424_243927",
    x: 71,
    y: 122,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.552941 0 0 0 0 0.929412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1424_243927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1424_243927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1424_243927",
    x: 9,
    y: 13,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.552941 0 0 0 0 0.929412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1424_243927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1424_243927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1424_243927",
    x: 19,
    y: 73,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.552941 0 0 0 0 0.929412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1424_243927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1424_243927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1424_243927",
    x: 84,
    y: 7,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.552941 0 0 0 0 0.929412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1424_243927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1424_243927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1424_243927",
    x: 68,
    y: 51,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.552941 0 0 0 0 0.929412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1424_243927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1424_243927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1424_243927",
    x: 4,
    y: 130,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.552941 0 0 0 0 0.929412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1424_243927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1424_243927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1424_243927",
    x: 44,
    y: 166,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.552941 0 0 0 0 0.929412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1424_243927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1424_243927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1424_243927",
    x1: 41.6708,
    y1: 83.9141,
    x2: 34.7133,
    y2: 104.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1424_243927",
    x1: 43.8443,
    y1: 93.4928,
    x2: 42.2349,
    y2: 94.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1424_243927",
    x1: 42.9589,
    y1: 83.3143,
    x2: 50.5962,
    y2: 103.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1424_243927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 194,
    rx: 8.81633,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetCloud);
export default __webpack_public_path__ + "static/media/get_cloud.7ad57552ba020fcf7d8f005ae0212b15.svg";
export { ForwardRef as ReactComponent };